export default "__VITE_ASSET__CegTJsDX__"